<template>
	<div :class="classes" class="outcome">
		<template v-if="processing && result === null">
			<loader/>
			<slot name="processingMessage">
				<div v-if="processingMessage" class="outcome__message">
					<p v-html="processingMessage"/>
				</div>
			</slot>
		</template>
		<template v-else>
			<Animation :key="key" :duration="350" :strokeWidth="2" class="outcome__icon" viewBox="0 0 100 100">
				<Fail v-if="!result"/>
				<Success v-else/>
			</Animation>
			<slot v-if="!result" name="errorMessage">
				<div v-if="message" class="outcome__message">
					<p v-html="message"/>
				</div>
			</slot>
			<slot v-else name="successMessage">
				<div v-if="message" class="outcome__message">
					<p v-html="message"/>
				</div>
			</slot>
		</template>
	</div>
</template>
<script>
import Animation from "./illustrations/Animation";
import Fail from "./illustrations/Fail";
import Success from "./illustrations/Success";

export default {
	components: {
		Animation,
		Success,
		Fail,
	},

	data() {
		return {
			key: 0,
		};
	},

	computed: {
		classes() {
			return {
				"outcome--processing": this.processing,
				"outcome--error": !this.result,
				"outcome--success": this.result,
			};
		},
	},

	props: {
		processing: {
			required: false,
			type: Boolean,
			default() {
				return false;
			},
		},
		result: {
			required: false,
			validator: prop => typeof prop === "boolean" || prop === null,
			default() {
				return null;
			},
		},
		processingMessage: {
			required: false,
			type: String,
		},
		message: {
			required: false,
			type: String,
		},
	},

	methods: {
		animate() {
			this.key++;
		},
	},

	watch: {
		"result": {
			handler() {
				this.animate();
			},
		},
		"message": {
			handler() {
				this.animate();
			},
		},
	},
};
</script>
